import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { MenuWrapper } from "./menu.styles.es.js";
const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node).isRequired
  ]).isRequired
};
const defaultProps = {};
const Menu = ({ children, ...restProps }) => /* @__PURE__ */ jsx(MenuWrapper, { ...restProps, children });
Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;
export {
  Menu
};
